import { notifications } from '@mantine/notifications';

interface NotificationOptions {
  title: string;
  message: string;
  color?: 'green' | 'red' | 'blue' | 'yellow';
  autoClose?: number;
}

export const showNotification = ({ title, message, color = 'green', autoClose }: NotificationOptions) => {
  notifications.show({
    title,
    message,
    color,
    styles: {
      root: {
        zIndex: 10, // Highest priority for notifications
      },
    },
    autoClose,
  });
};

// Common notification types
export const showAddedToCartNotification = (itemName: string, type: 'success' | 'error' = 'success') => {
  showNotification({
    title: type === 'success' ? 'Added to cart' : 'Error',
    message: type === 'success' ? `${itemName} has been added to your cart` : itemName,
    color: type === 'success' ? 'green' : 'red',
    autoClose: 1500,
  });
}; 